import { createStore } from 'vuex';
import App from '@/toremove/stores/app.js';
import User from '@/toremove/stores/user.js';
import Userv2 from '@/octolo/user/store/user.js';

export default createStore({ modules:{ App, User, Userv2 } });
